import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export class ItineraryContentBlockDoubleImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
    }

    this.handleClickTracking = this.props.handleClickTracking.bind(this)
  }

  render() {
    const firstButtonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.firstButtonIcon)
    const firstButtonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.firstButtonColor)
    const secondButtonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.secondButtonIcon)
    const secondButtonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.secondButtonColor)
    return (
      <div className="departure-info__essentials__detailitems__detailitem__infobox__double-image">
        <div className="grid">
          <div className="grid-item col--12 col-sm--6">
            <div className="departure-info__essentials__detailitems__detailitem__infobox__content__block">
              <div className="foto-container">
                <div className="no-foto">
                  <img src={this.props.block.firstImage} />
                </div>
              </div>
              <div className="info-text" dangerouslySetInnerHTML={{ __html: this.props.block.firstText }}></div>
              {this.props.block.firstButtonText && this.props.block.firstButtonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general rm-this-class rm-this-class-hide-default ${
                      firstButtonColor ? firstButtonColor : "casc-blue"
                    }`}
                    href={this.props.block.firstButtonLink}
                    onClick={() => this.handleClickTracking(this.props.block.firstButtonTracking)}
                  >
                    {firstButtonSvg !== "" ? <Svg iconName={firstButtonSvg} /> : ""}
                    <span className="text">{this.props.block.firstButtonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="grid-item col--12 col-sm--6">
            <div className="departure-info__essentials__detailitems__detailitem__infobox__content__block">
              <div className="foto-container">
                <div className="no-foto">
                  <img src={this.props.block.secondImage} />
                </div>
              </div>
              <div className="info-text" dangerouslySetInnerHTML={{ __html: this.props.block.secondText }}></div>
              {this.props.block.secondButtonText && this.props.block.secondButtonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general rm-this-class rm-this-class-hide-default ${
                      secondButtonColor ? secondButtonColor : "casc-blue"
                    }`}
                    href={this.props.block.secondButtonLink}
                    onClick={() => this.handleClickTracking(this.props.block.secondButtonTracking)}
                  >
                    {secondButtonSvg !== "" ? <Svg iconName={secondButtonSvg} /> : ""}
                    <span className="text">{this.props.block.secondButtonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}
